module.exports = __webpack_public_path__ + "static/media/rohit-n.4f3db9cc.jpeg";